import { Component, h } from 'preact'
import AlertComponent from '../ui-components/AlertComponent'

interface Props {}
interface State {
  showAlert: boolean
}

class BadgesOverview extends Component<Props, State> {
  constructor () {
    super()
    this.state = {
      showAlert: false
    }
  }
  componentDidMount (): void {
    if (this.queryParameterMatches('badgeAwarded')) {
      this.setState({ showAlert: true })
      window.history.pushState(null, '', 'overview')
    }
  }

  queryParameterMatches (parameter: string) {
    return window.location.search.match(parameter)
  }

  render (props: Props, state: State) {
    return state.showAlert && <AlertComponent
      messageType='success'
      message='Badge has been successfully awarded'
      isVisibleFor={5000}
      sticky
    />
  }
}

export default BadgesOverview
